export enum RouteType {
	url, // Route represented by URL. Opened in new tab.
	name, // Represented by unmodified name in Vuex Router routes.
	listName, // Represented by name appended with 'List' in Vuex Router routes.
	method, // Route represented by custom method which returns string.
	external, // Route to access urls inside external modules such as MPOV
	web, // Route to access addresses outside DMS, on the internet
}

export const MENU_CISELNIKY = 'Ciselniky';
export const MENU_OJETEVOZY = 'OjeteVozy';
export const MENU_CISELNIK_OV = 'CiselnikOjeteVozy';
export const MENU_NV = 'NV_NoveVozy';
export const EXTERNAL_MENU_CISELNIK = 1;
export const EXTERNAL_MENU_CISELNIK_OV = 0;
export const EXTERNAL_MENU_OV = 0;

export const ServiceOrder = 'Zakazka';
export const IncludedInOrderList = <const>[
	'ZakazkaList',
	'NdObjednavkaZakazka',
	'JednotnaFrontaNd',
	'ServisniPaket',
	'SplitBilling',
	'Fakturace',
];
